import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import IntakeForm from "@/pages/IntakeForm";
import PartialResult from "@/pages/PartialResult";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminSubmissionDetail from "@/pages/AdminSubmissionDetail";
import FullResult from "@/pages/FullResult";

const TOAST_OPTIONS = {
  style: {
    background: "#FAF5EE",
    color: "#190F08",
    border: "1px solid #A88059",
    borderRadius: 0,
    fontFamily: "EB Garamond, Georgia, serif",
  },
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<IntakeForm />} />
          <Route path="/submission/:id" element={<PartialResult />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/submissions/:id" element={<AdminSubmissionDetail />} />
          <Route path="/results/:token" element={<FullResult />} />
        </Routes>
        <Toaster theme="light" position="top-right" toastOptions={TOAST_OPTIONS} />
      </BrowserRouter>
    </div>
  );
}

export default App;
